import React from 'react';
import { useEffect } from 'react';
import { useRouteById, useRouteDetailById } from '../../../hooks/useRouteById';
import { LoadingLogoComponent } from '../../Quotes/LoadingLogoComponent';
import { RouteDetailsComponentMap } from './routeDetailsUtils';

interface Props {
  routeId: string;
}

export const RouteDetails: React.FC<Props> = ({ routeId }) => {
  const { data, isLoading, refetch } = useRouteDetailById(routeId);
  const { data: routeData } = useRouteById([routeId]);

  useEffect(() => {
    refetch();
  }, [routeId]);

  if (isLoading) {
    return <LoadingLogoComponent />;
  }
  if (data && data[0])
    return (
      <div className="flex flex-col gap-3 overflow-auto">
        {data[0].routeDetails.map((detail, index) => {
          const Component = RouteDetailsComponentMap[detail.type].component;
          const props = { ...detail.data, route: routeData && routeData[0] ? routeData[0] : undefined };

          return (
            <div key={index} style={{ paddingLeft: detail.offset + 'rem' }}>
              <Component {...props} />
            </div>
          );
        })}
      </div>
    );

  return <div>Route Details are not available</div>;
};
